import { cosemApi } from '@services/providers/cosem';
import { List } from './list.types';
import { ApiResponse } from '@services/providers/cosem.types';
import { TicketType } from './ticket-types/ticket-types.types';

const listApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getOrganizationCodes: build.mutation<ApiResponse<List[]>, undefined>({
            query: () => {
                return { 
                    url: `/member/organization-codes`,
                    method: 'GET',
                };
            },
            transformResponse: (response: ApiResponse<List[]>) => response
        }),
        getServiceCodes: build.mutation<ApiResponse<List[]>, undefined>({
            query: () => {
                return { 
                    url: `/member/service-codes`,
                    method: 'GET',
                };
            },
            transformResponse: (response: ApiResponse<List[]>) => response
        }),
        getStateCodes: build.mutation<ApiResponse<List[]>, undefined>({
            query: () => {
                return { 
                    url: `/member/state-codes`,
                    method: 'GET',
                };
            },
            transformResponse: (response: ApiResponse<List[]>) => response
        }),
        getTicketTypes: build.mutation<ApiResponse<TicketType[]>, undefined>({
            query: () => {
                return { 
                    url: `/member/ticket-types`,
                    method: 'GET',
                };
            },
            transformResponse: (response: ApiResponse<TicketType[]>) => response
        })
    })
});

export const { 
    useGetOrganizationCodesMutation, 
    useGetServiceCodesMutation,
    useGetStateCodesMutation,
    useGetTicketTypesMutation
} = listApi;
